import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import {
  HotelPurchaseAddOnsItemFormType,
  HotelPurchaseFormType,
  HotelPurchaseHotelItemFormType,
} from '../components/form-type';

export function calculateHotelPurchaseDetail(
  details: HotelPurchaseHotelItemFormType[],
  isByPax: boolean,
) {
  const total = details.reduce((prev, hpg) => {
    const price = hpg.price || 0;
    const night = hpg.night || 0;
    const room = hpg.room || 0;
    const pax = hpg.pax || 0;

    if (isByPax) {
      const total = price * pax;
      return prev + total;
    } else {
      const total = price * night * room;
      return prev + total;
    }
  }, 0);

  return total;
}

export function calculateHotelPurchaseAddons(
  addons: HotelPurchaseAddOnsItemFormType[],
) {
  const total = addons.reduce((prev, hpao) => prev + (hpao.price || 0), 0);
  return total;
}

export default function useRecalculate() {
  const { control, setValue } = useFormContext<HotelPurchaseFormType>();
  const [hotelPurchases, otherCost, discount] = useWatch({
    control,
    name: ['hotelPurchases', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = (hotelPurchases || []).reduce((prev, hp) => {
      const subtotalGuest = calculateHotelPurchaseDetail(
        hp.hotelPurchaseHotels,
        hp.isByPax,
      );

      const subtotalAddOns = calculateHotelPurchaseAddons(
        hp.hotelPurchaseAddOns,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [discount, hotelPurchases, otherCost, setValue]);

  return data;
}
